<template>
  <div>
    <h3 class="title">本月TOP</h3>
    <a-tabs default-active-key="1" :animated="false" size="small" :tabBarGutter="24">
      <a-tab-pane key="1" tab="单品TOP10">
        <div class="table-wrapper">
          <a-table 
            :columns="spuColumns" 
            :data-source="spuTop5" 
            :pagination="false"
            size="middle"
            rowKey="spu_id"
          >
            <div slot="rank" slot-scope="text">
              <img v-if="text===1" src="@assets/images/icon-order-1.png" style="width:18px;height:18px"/>
              <img v-if="text===2" src="@assets/images/icon-order-2.png" style="width:18px;height:18px"/>
              <img v-if="text===3" src="@assets/images/icon-order-3.png" style="width:18px;height:18px"/>
              <span v-if="text>3">{{text}}</span>
            </div>
            <span slot="spu_title" slot-scope="text" class="textellipsis" :title="text">
              {{text}}
            </span>
            <div slot="salesAmount" slot-scope="text, record">
              {{text}}{{record.unit}}
            </div>
            <div slot="mom" slot-scope="text">
              <a-statistic 
                :value="Math.abs(text)" 
                :class="+text < 0 ? 'ratio down' : +text > 0 ? 'ratio up' : 'ratio'" 
                suffix="%">
                <template #prefix>
                  <img v-if="+text < 0" src="@assets/images/icon-down.png" style="width: 12px; height: 12px;" />
                  <img v-if="+text > 0" src="@assets/images/icon-up.png" style="width: 12px; height: 12px;" />
                </template>
              </a-statistic>
            </div>
          </a-table>
          <a-table 
            :columns="spuColumns" 
            :data-source="spuTop10" 
            :pagination="false"
            size="middle"
            rowKey="spu_id"
          >
            <span slot="spu_title" slot-scope="text" class="textellipsis" :title="text">
              {{text}}
            </span>
            <div slot="salesAmount" slot-scope="text, record">
              {{text}}{{record.unit}}
            </div>
            <div slot="mom" slot-scope="text">
              <a-statistic 
                :value="Math.abs(text)" 
                :class="+text < 0 ? 'ratio down' : +text > 0 ? 'ratio up' : 'ratio'" 
                suffix="%">
                <template #prefix>
                  <img v-if="+text < 0" src="@assets/images/icon-down.png" style="width: 12px; height: 12px;" />
                  <img v-if="+text > 0" src="@assets/images/icon-up.png" style="width: 12px; height: 12px;" />
                </template>
              </a-statistic>
            </div>
          </a-table>
        </div>
      </a-tab-pane>
      <a-tab-pane key="2" tab="门店TOP10">
        <div class="table-wrapper">
          <a-table 
            :columns="storeColumns" 
            :data-source="storeTop5" 
            :pagination="false"
            size="middle"
            rowKey="store_code"
          >
            <div slot="rank" slot-scope="text">
              <img v-if="text===1" src="@assets/images/icon-order-1.png" style="width:18px;height:18px"/>
              <img v-if="text===2" src="@assets/images/icon-order-2.png" style="width:18px;height:18px"/>
              <img v-if="text===3" src="@assets/images/icon-order-3.png" style="width:18px;height:18px"/>
              <span v-if="text>3">{{text}}</span>
            </div>
            <span slot="store_name" slot-scope="text" class="textellipsis" :title="text">
              {{text}}
            </span>
            <div slot="salesAmount" slot-scope="text, record">
              {{text}}{{record.unit}}
            </div>
            <div slot="mom" slot-scope="text">
              <a-statistic 
                :value="Math.abs(text)" 
                :class="+text < 0 ? 'ratio down' : +text > 0 ? 'ratio up' : 'ratio'" 
                suffix="%">
                <template #prefix>
                  <img v-if="+text < 0" src="@assets/images/icon-down.png" style="width: 12px; height: 12px;" />
                  <img v-if="+text > 0" src="@assets/images/icon-up.png" style="width: 12px; height: 12px;" />
                </template>
              </a-statistic>
            </div>
          </a-table>
          <a-table 
            :columns="storeColumns" 
            :data-source="storeTop10" 
            :pagination="false"
            size="middle"
            rowKey="store_code"
          >
            <span slot="store_name" slot-scope="text" class="textellipsis" :title="text">
              {{text}}
            </span>
            <div slot="salesAmount" slot-scope="text, record">
              {{text}}{{record.unit}}
            </div>
            <div slot="mom" slot-scope="text">
              <a-statistic 
                :value="Math.abs(text)" 
                :class="+text < 0 ? 'ratio down' : +text > 0 ? 'ratio up' : 'ratio'" 
                suffix="%">
                <template #prefix>
                  <img v-if="+text < 0" src="@assets/images/icon-down.png" style="width: 12px; height: 12px;" />
                  <img v-if="+text > 0" src="@assets/images/icon-up.png" style="width: 12px; height: 12px;" />
                </template>
              </a-statistic>
            </div>
          </a-table>
        </div>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
  import { Statistic, Tabs, Table } from "ant-design-vue"
  import _ from 'lodash'
  const { TabPane } = Tabs
  export default {
    name: 'realtime-rank',
    components: {
      [Statistic.name]: Statistic,
      [Tabs.name]: Tabs,
      [TabPane.name]: TabPane,
      [Table.name]: Table
    },
    data() {
      return {
        spuTop5: [],
        spuTop10: [],
        storeTop5: [],
        storeTop10: [],
        spuColumns: [
          {
            title: '综合排名',
            key: 'rank',
            dataIndex: 'rank',
            scopedSlots: { customRender: 'rank' },
            width: 80,
            align: 'center'
          },
          {
            title: 'SPU',
            key: 'spu_title',
            dataIndex: 'spu_title',
            scopedSlots: { customRender: 'spu_title' },
            // width: 210,
            align: 'center'
          },
          {
            title: '销售金额',
            key: 'salesAmount',
            dataIndex: 'salesAmount',
            scopedSlots: { customRender: 'salesAmount' },
            width: 130,
            align: 'center'
          },
          {
            title: '环比',
            key: 'mom',
            dataIndex: 'mom',
            scopedSlots: { customRender: 'mom' },
            width: 100,
            align: 'center'
          },
        ],
        storeColumns: [
          {
            title: '综合排名',
            key: 'rank',
            dataIndex: 'rank',
            scopedSlots: { customRender: 'rank' },
            width: 80,
            align: 'center'
          },
          {
            title: '门店',
            key: 'store_name',
            dataIndex: 'store_name',
            scopedSlots: { customRender: 'store_name' },
            // width: 210,
            align: 'center'
          },
          {
            title: '销售金额',
            key: 'salesAmount',
            dataIndex: 'salesAmount',
            scopedSlots: { customRender: 'salesAmount' },
            width: 130,
            align: 'center'
          },
          {
            title: '环比',
            key: 'mom',
            dataIndex: 'mom',
            scopedSlots: { customRender: 'mom' },
            width: 100,
            align: 'center'
          },
        ]
      }
    },
    async created() {
      const res = await this.$store.dispatch('partnerHome/queryHomeTopTen')
      if (res && +res.code === 0) {
        let spus = _.get(res, ['data', 'sPU']) || []
        let stores = _.get(res, ['data', 'store']) || []
        this.spuTop5 = spus.filter(item => item.rank <= 5).sort((a, b) => a.rank - b.rank)
        this.spuTop10 = spus.filter(item => item.rank > 5 && item.rank <= 10).sort((a, b) => a.rank - b.rank)
        this.storeTop5 = stores.filter(item => item.rank <= 5).sort((a, b) => a.rank - b.rank)
        this.storeTop10 = stores.filter(item => item.rank > 5 && item.rank <= 10).sort((a, b) => a.rank - b.rank)
      }
    },
  }
</script>
<style scoped lang="scss">
  h3.title {
    font-size: 14px;
    font-family: MicrosoftYaHei, PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    line-height: 18px;
    margin-bottom: 2px;
    margin-top: 20px;
  }
  .table-wrapper {
    display: flex;
    /* justify-content: space-between; */
  }
  .ant-table-wrapper {
    margin-right: 20px;
    flex: 1;
  }
  .textellipsis {
    display: inline-block;
    width: 210px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .ratio {
    /deep/.ant-statistic-content {
      font-size: 14px;
      font-weight: 400;
      color: #666666;
    }
    /deep/.ant-statistic-content-value-decimal {
      font-size: 14px;
    }
    
    /deep/.ant-statistic-content-suffix {
      font-size: 14px;
      margin-left: 0;
    }
    /deep/.ant-statistic-content-prefix {
      margin-right: 0;
    }
  }
  .up {
    /deep/.ant-statistic-content-value-int {
      color: #FF184F;
    }
    /deep/.ant-statistic-content-value-decimal {
      color: #FF184F;
    }
    /deep/.ant-statistic-content-suffix {
      color: #FF184F;
    }
  } 
  .down {
    /deep/.ant-statistic-content-value-int {
      color: #1ECA6E;
    }
    /deep/.ant-statistic-content-value-decimal {
      color: #1ECA6E;
    }
    /deep/.ant-statistic-content-suffix {
      color: #1ECA6E;
    }
  } 
</style>
